import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QContentQuestionUsageList } from '@exam-management/qcontent-question-usage-list';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ItemSetSubQuestionUsagePage() {
  const { subQuestionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/question-usage',
  );
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.EXAM.EXAMINATION_COURSE.VIEW,
        APP_PERMISSIONS.EXAM.QSET.VIEW,
      ]}
    >
      <Box sx={{ p: (theme) => theme.spacing(6) }}>
        <QContentQuestionUsageList questionId={subQuestionId} />
      </Box>
    </PermissionGuard>
  );
}
